import type { ToolDescriptor } from "../tool";
import { giraffeStateTool } from "./giraffe";
import { giraffeSdkPatchPlan, giraffeSdkRead, giraffeSdkWrite } from "./sdk";
export { GEO_STATE_KEYS, STATE_KEYS } from "./giraffe";

/**
 * The fixed host set (`docs/tool-surface.md`) minus the two relay tools: everything here is
 * answered by a browser frame — but it is ADVERTISED in every session
 * state, and are a named `no_session` when called without one. See
 * `RelayCore.FIXED_CATALOGUE` for why the list no longer narrows at all.
 * The generic SDK tools are NOT here — they are `SDK_TOOLS`, answered by the
 * control frame alone. Grouping them apart is documentation; routing treats every
 * frame-answered tool identically (`relay/sessions.ts`'s `resolveImplementor`).
 */
export const HOST_TOOLS: readonly ToolDescriptor[] = [giraffeStateTool];

export { SDK_TOOLS } from "./sdk";

/**
 * Every tool a BROWSER FRAME answers — the fixed host set plus the SDK tools.
 *
 * The SDK pair, `giraffe_state`, and `giraffe_sdk_patch`, a safety
 * primitive (#41). `giraffe_sdk_describe` is relay-answered and lives in
 * `RELAY_TOOLS`. `giraffe_state` stays because it reads PUSHED state, a channel
 * the SDK tools cannot reach. A tool that wraps one host RPC does not
 * belong here until repeated use earns it one.
 *
 * `giraffe_sdk_patch` appears here as `giraffeSdkPatchPlan`, NOT as the
 * agent-facing descriptor in `SDK_TOOLS`: the frame receives the relay's plan.
 *
 * This is the set a frame picks from when it declares what it implements, and
 * it is deliberately one list: a frame that declares a tool it cannot answer
 * is the routing-by-recency defect (#24) in a new coat.
 */
export const FRAME_ANSWERED_TOOLS: readonly ToolDescriptor[] = [
  giraffeStateTool,
  giraffeSdkRead,
  giraffeSdkWrite,
  giraffeSdkPatchPlan,
];

export { APP_CALL_NAME, APP_TOOLS_NAME, RELAY_TOOLS } from "./relay";
